// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"508":"7afc324b","670":"6ea2a296","787":"d91ea4fc","790":"68d4eb08","883":"9843dc5d"}[chunkId] + ".chunk.js";
};